import { type FC } from "react";

import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// "✓ Saved", teal, ahead of a line, after an edit is saved.
export const SavedMark: FC = () => (
  <span className="mr-2 inline-flex items-center gap-1 font-medium text-teal-700">
    <FontAwesomeIcon icon={faCheck} />
    Saved
  </span>
);
